import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Avatar, Box, Stack, styled, Typography } from "@mui/material";
import CabinIcon from '@mui/icons-material/Cabin';
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IcpInspectionSummaryGrid from "./IcpInspectionSummaryGrid";
import IcpInspectionNetworkApproval from "./IcpInspectionNetworkApproval";


const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    background: '#fafbfc',
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    borderTop: '1px solid #f1f2f3',
    paddingTop: theme.spacing(2),
}));

export default function IcpInspectionDetailsAccordion({ title = '', workOrderId, icpNumber, workOrderDetails }) {

    const [expanded, setExpanded] = useState('summary')

    const handleChangeAccordion = ((accordionName, isExpanded) => {
        setExpanded(isExpanded ? accordionName : null)
    })

    const formatContactDetails = (label, name, email, phone) => {
        const dashedItems = []
        if (name) {
            dashedItems.push(name)
        }
        if (email) {
            dashedItems.push(email)
        }
        if (phone) {
            dashedItems.push(phone)
        }
        return (label || '') + ': ' + dashedItems.join(' - ')
    }
    const electricianDetails = formatContactDetails('Electrician',
        workOrderDetails?.workOrder?.electricianContact?.name,
        workOrderDetails?.workOrder?.electricianContact?.email,
        workOrderDetails?.workOrder?.electricianContact?.phone,
    )
    const customerDetails = formatContactDetails('Customer',
        (workOrderDetails?.workOrder?.customerContact?.firstName || '') + ' ' + (workOrderDetails?.workOrder?.customerContact?.lastName || ''),
        workOrderDetails?.workOrder?.customerContact?.email,
        workOrderDetails?.workOrder?.customerContact?.primaryPhone,
    )
    return (
        <Box>
            <Box>
                <Stack direction="row" spacing={2} sx={{ my: 1, alignItems: 'center' }}>
                    <Avatar alt={title}><CabinIcon /></Avatar>
                    <h2 className="np-title">{title}</h2>
                </Stack>
                <Typography sx={{ my: 1 }} variant="h4">{workOrderDetails?.workOrder?.streetAddress}</Typography>
                {
                    workOrderDetails?.workOrder?.registryStatus === 'new' &&
                    <Alert severity="warning">
                        <AlertTitle>
                            <strong>ICP</strong> is in <strong>New</strong> status, ICP Inspection is not yet ready
                        </AlertTitle>
                        Please have the electrician or customer contact the retailer to accept the ICP so the registry can be updated. <br />
                        Contact Northpower Customer Care to discuss further if required - 0800 667 847<br />
                        {workOrderDetails?.workOrder?.electricianContact &&
                            <> {electricianDetails} <br /> </>
                        }
                        {workOrderDetails?.workOrder?.customerContact &&
                            customerDetails
                        }
                    </Alert>
                }
            </Box>

            <Accordion
                expanded={expanded === 'summary'}
                onChange={(event, isExpanded) => handleChangeAccordion('summary', isExpanded)}
                square
                disableGutters
            >
                <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Inspection Summary</Typography>
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                    <IcpInspectionSummaryGrid workOrderId={workOrderId} icpNumber={icpNumber} workOrderDetails={workOrderDetails} />
                </StyledAccordionDetails>
            </Accordion>

            {
                workOrderDetails?.workOrder?.registryStatus !== 'new'
                &&
                <Accordion
                    expanded={expanded === 'network_approval'}
                    onChange={(event, isExpanded) => handleChangeAccordion('network_approval', isExpanded)}
                    square
                    disableGutters
                >
                    <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Network Approval</Typography>
                    </StyledAccordionSummary>
                    <StyledAccordionDetails>
                        <IcpInspectionNetworkApproval
                            title="Network Approval"
                            workOrderId={workOrderId}
                            icpNumber={icpNumber}
                            workOrderDetails={workOrderDetails}
                        />
                    </StyledAccordionDetails>
                </Accordion>
            }
        </Box>
    )
}